/*
 * Copyright (c) 2021. American Express Company
 */

export enum TypographyVariants {
    HEADING_XL = 'headingXL',
    HEADING_L = 'headingL',
    HEADING_M = 'headingM',
    HEADING_S = 'headingS',
    HEADING_XS = 'headingXS',

    BODY = 'body',
    BODY_BOLD = 'bodyBold',

    LINK = 'link',
    LINK_2 = 'link_2',

    SUBTEXT = 'subtext',
    SUBTEXT_BOLD = 'subtextBold',

    CAPTION = 'caption',

    LEGAL_PRIMARY = 'legalPrimary',
    LEGAL_SECONDARY = 'legalSecondary',
    LEGAL_TERTIARY = 'legalTertiary'
}
